import '@src/util/polyfills';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { responseErrorRedirectInterceptor } from '@src/util/axios';
import ReactModal from 'react-modal';
import { Modal } from 'sous-chef';
import '@7shifts/sous-chef-base/dist/index.css';
import { initializeSentry } from '@src/App/Sentry';
import AppRouter from '@src/App/AppRouter';

axios.interceptors.response.use(r => r, responseErrorRedirectInterceptor);
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const appRoot = document.getElementById('app');

initializeSentry();
if (appRoot) {
    Modal.setAppElement(appRoot);
    // Update it to use the new React 18 render once all the consurrent mode issues is fixed.
    ReactModal.setAppElement(appRoot);
    ReactDOM.render(<AppRouter />, appRoot);
}
